import React from 'react';
import { PropTypes } from 'prop-types';

import { Radio, Form } from 'antd';

const ProcessingSummaryForm = ({
  form,
}) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
  >
    <Form.Item
      label="Next created"
      name="next_summary_created"
    >
      <Radio.Group>
        <Radio value>Yes</Radio>
        <Radio value={false}>No</Radio>
      </Radio.Group>
    </Form.Item>
  </Form>
);

ProcessingSummaryForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

ProcessingSummaryForm.defaultProps = {
  form: {},
};

export default ProcessingSummaryForm;
